import * as urls from "../../api/C4S Decommission - Replacement/url";
import { postRequest } from "../../../services/RestServices";

export const addLostShipment = async (payload) => {
  try {
    return await postRequest(urls.ADD_LOST_SHIPMENT, payload);
  } catch (err) {
    return err;
  }
};
